// src/services/trades.js
import axios from "axios";

export const sendTradeService = (payload) =>
  axios.post("/api/trades/send", payload, { withCredentials: true });

export const tradeHistoryService = (scope = "all", limit = 80) =>
  axios.get(`/api/trades/history?scope=${scope}&limit=${limit}`, { withCredentials: true });

export const checkUserService = (q) =>
  axios.get(`/api/trades/check-user?q=${encodeURIComponent(q)}`, { withCredentials: true });
